import { Ref, ref, watch, WatchStopHandle } from '@vue/composition-api';
import * as storymapStoreModule from '../../store';
import { Subtask } from '../types';

const taskReleasSubtasks: any = {};

// Tells replaced card objects apart in the watched text, because a new object can have the same id, place and order.
const objectSerials = new WeakMap<object, number>();
let lastObjectSerial = 0;
const objectSerial = (card: object): number => {
    let serial = objectSerials.get(card);
    if (serial === undefined) {
        serial = ++lastObjectSerial;
        objectSerials.set(card, serial);
    }
    return serial;
};
let watchHandler: WatchStopHandle = null;

export const getTaskRelease = (releaseId: string, taskId: string): Ref<Subtask[]> => {
    const key = releaseId + '|' + taskId;

    if (!taskReleasSubtasks.hasOwnProperty(key)) {
        addTaskRelase(releaseId, taskId, []);
    }

    return taskReleasSubtasks[key];
};

export const refreshTaskReleases = () => {
    const state = storymapStoreModule.useStorymapStore().state;

    for (const release of state.releases) {
        for (const task of state.tasks) {
            const currentSubtasks = state.subtasks.filter((x) => x.releaseId == release.id && x.taskId == task.id);
            replaceTaskRelase(release.id, task.id, currentSubtasks);
        }
    }
};

export const initTaskRelease = () => {
    const state = storymapStoreModule.useStorymapStore().state;

    for (const release of state.releases) {
        for (const task of state.tasks) {
            const currentSubtasks = state.subtasks.filter((x) => x.releaseId == release.id && x.taskId == task.id);
            addTaskRelase(release.id, task.id, currentSubtasks);
        }
    }

    if (!watchHandler) {
        watchHandler = watch(
            () => state.subtasks.map((x) => `${objectSerial(x)}|${x.id}|${x.releaseId}|${x.taskId}|${x.order}`).join(','),
            () => {
                //const startTime = performance.now();
                //Add news and update exists
                for (const subtask of state.subtasks) {
                    const array = getTaskRelease(subtask.releaseId, subtask.taskId);

                    const current = array.value.find((x) => x.id == subtask.id);
                    if (current && current !== subtask) {
                        array.value.splice(array.value.indexOf(current), 1, subtask);
                    } else if (current) {
                        if (current.order != subtask.order) {
                            //console.log('updated', subtask.title, subtask.order, current.order);
                            current.order = subtask.order;
                        }
                    } else {
                        //console.log('added', subtask);
                        array.value.push(subtask);
                    }
                }

                //Remove olds: cards in another lane now, deleted cards, and objects replaced by a new object of the same card
                const currentById = new Map(state.subtasks.map((s) => [s.id, s]));
                for (const key in taskReleasSubtasks) {
                    const array = taskReleasSubtasks[key];
                    const { releaseId, taskId } = destructKey(key);

                    const belongs = (x: any) => x.releaseId == releaseId && x.taskId == taskId && currentById.get(x.id) === x;
                    if (!array.value.every(belongs)) {
                        array.value = array.value.filter(belongs);
                    }
                }
                //const endTime = performance.now();
                //console.log(` ----- Watch state.subtasks ------ ${endTime - startTime} milliseconds`);
            },
            { immediate: false }
        );
    }
};

const addTaskRelase = (releaseId: string, taskId: string, subtasks: Subtask[]) => {
    const key = generateKey(releaseId, taskId);
    taskReleasSubtasks[key] = ref(subtasks);
};

const replaceTaskRelase = (releaseId: string, taskId: string, subtasks: Subtask[]) => {
    const key = generateKey(releaseId, taskId);
    if (taskReleasSubtasks.hasOwnProperty(key)) {
        taskReleasSubtasks[key].value = subtasks;
    } else {
        taskReleasSubtasks[key] = ref(subtasks);
    }
};

const generateKey = (releaseId: string, taskId: string): string => {
    const key = releaseId + '|' + taskId;
    return key;
};

const destructKey = (key: string): { releaseId: string; taskId: string } => {
    const array = key.split('|');

    return {
        releaseId: array[0] == 'null' ? null : array[0],
        taskId: array[1],
    };
};
